import { IntegrityMonitorRegistryValueRuleFormWebComponent } from './component/IntegrityMonitorRegistryValueRuleFormWebComponent';
import { WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_REGISTRYVALUE_FORM } from '../../../../webcomponents.constants';

export { IntegrityMonitorRegistryValueRuleFormWebComponent };

window.customElements.define(
  WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_REGISTRYVALUE_FORM,
  IntegrityMonitorRegistryValueRuleFormWebComponent
);
